/** Uçuştaki API isteği sayacı (yalnız sayfa verisi).
 *
 * Altbilgi, içerik verisi gelene kadar görünmez (lib/settledFooter.js);
 * "veri geldi" sinyali budur. Uzun yoklamalar (bakiye bekleme, canlı mesaj)
 * sayılmaz: onlar hiç bitmeyen istektir ve sayaç sıfıra inmezdi.
 */
const LONG_POLL = /(balance\/wait|messages\/live|heartbeat)/;
let pending = 0;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(pending));

export const countable = (url) => !LONG_POLL.test(String(url || ''));

export function started(cfg) {
  if (cfg && !cfg.__inflight && countable(cfg.url)) {
    cfg.__inflight = true;
    pending += 1;
    emit();
  }
  return cfg;
}

export function finished(cfg) {
  if (cfg && cfg.__inflight) {
    cfg.__inflight = false;
    pending = Math.max(0, pending - 1);
    emit();
  }
}

export const inflight = () => pending;

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
